import { ServerErrComponent } from '../components/ServerErrComponent'
import { usePageTitle } from '../hooks/usePageTitle'

export const UnAuthorizedPage = () => {
  const title = usePageTitle('هذا الحساب لايملك صلاحية')

  return <ServerErrComponent title={title} src={'/401.svg'} />
}
